export abstract class BaseDecorator {
  constructor(protected object: any) {}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/decorators/base.decorator.ts